module.exports = __webpack_public_path__ + "img/download-google-play.721fbae9.png";